import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { type ConfirmActionVariant } from '@/app/pages/notifications/announcements/core/_models';

type ConfirmActionModalProps = {
  title: string;
  question: string;
  confirmLabel: string;
  variant: ConfirmActionVariant;
  isPending: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/** Publicar, encerrar e excluir pedem a mesma confirmação; o texto diz qual. */
function ConfirmActionModal({
  title,
  question,
  confirmLabel,
  variant,
  isPending,
  onConfirm,
  onClose,
}: ConfirmActionModalProps) {
  return (
    <Modal centered show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0 fw-semibold text-gray-700">{question}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="text-gray-600" variant="secondary" onClick={onClose}>
          Voltar
        </Button>
        <Button disabled={isPending} variant={variant} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmActionModal;
